/**
 * @module funcao/ui/funcaoui
 */

import { Plugin } from 'ckeditor5/src/core';
import { addListToDropdown, createDropdown, Model } from 'ckeditor5/src/ui';
import { Collection } from 'ckeditor5/src/utils';
import '../theme/funcao.pcss';
import FuncaoEditing from './funcaoediting';

const FUNCAO = 'funcao';

/**
 * The funcao UI plugin.
 *
 * It introduces the `'funcao'` button and toolbar.
 *
 * @extends {Plugin}
 */
export default class FuncaoUI extends Plugin {
	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'FuncaoUI';
	}

	/**
	 * @inheritDoc
	 */
	static get requires() {
		return [ FuncaoEditing ];
	}

	/**
	 * @inheritDoc
	 */
	init() {
		const editor = this.editor;
		const label = "Função";
		const dropdownTooltip = "Adicionar função";
		this._config = editor.config.get( FUNCAO ) || {};
		/**
		 * @type {Array<Funcao>}
		 */
		const options = editor.config.get( FUNCAO ) && editor.config.get( FUNCAO ).lista || [];
		const command = editor.commands.get( FUNCAO );

		// Register UI component.
		editor.ui.componentFactory.add( FUNCAO, locale => {
			const dropdownView = createDropdown( locale );

			const itemDefinitions = new Collection();
			for ( const option of options ) {
				const def = {
					type: 'button',
					model: new Model( {
						commandName: FUNCAO,
						commandParam: option.codigo,
						label: option.descricao,
						withText: true
					} )
				};
				itemDefinitions.add( def );
			}

			addListToDropdown( dropdownView, itemDefinitions );

			dropdownView.buttonView.set( {
				label: label,
				tooltip: dropdownTooltip,
				withText: true
			} );

			dropdownView.extendTemplate( {
				attributes: {
					class: 'ck-funcao-dropdown'
				}
			} );

			dropdownView.bind( 'isEnabled' ).to( command );

			this.listenTo( dropdownView, 'execute', evt => {
				editor.execute( evt.source.commandName, {
					codigo: evt.source.commandParam
				} );
				editor.editing.view.focus();
			} );

			return dropdownView;
		} );
	}
}
